import { useTranslation } from "react-i18next";
import { useOffline } from "../lib/offline-context.js";
import { usePendingPhotosCount } from "../lib/use-pending-photos-count.js";
import type { ConnectionState } from "../lib/offline-context.js";

const VARIANTS: Record<ConnectionState, { labelKey: string; className: string }> = {
  online: {
    labelKey: "sync.online",
    className: "bg-emerald-100 text-emerald-900",
  },
  offline: {
    labelKey: "sync.offline",
    className: "bg-amber-100 text-amber-900",
  },
  "server-unavailable": {
    labelKey: "sync.serverUnavailable",
    className: "bg-orange-100 text-orange-900",
  },
};

export function SyncBanner() {
  const { t, i18n } = useTranslation();
  const { connectionState, queueLength, lastSync, flush } = useOffline();
  const photos = usePendingPhotosCount();
  const variant = VARIANTS[connectionState];
  const canSync = connectionState === "online";

  return (
    <div
      data-testid="sync-banner"
      className={`text-xs px-3 py-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 ${variant.className}`}
    >
      <span className="font-medium">● {t(variant.labelKey)}</span>
      {queueLength > 0 && <span>{t("sync.pendingMutations", { count: queueLength })}</span>}
      {photos > 0 && <span>{t("sync.pendingPhotos", { count: photos })}</span>}
      {lastSync && (
        <span className="text-muted-foreground">
          {t("sync.lastSync", { date: new Date(lastSync).toLocaleTimeString(i18n.language) })}
        </span>
      )}
      <button
        onClick={() => flush().catch(() => undefined)}
        className="ml-auto underline disabled:opacity-50"
        disabled={!canSync}
      >
        {t("sync.syncNow")}
      </button>
    </div>
  );
}
